<template>
  <div class="right">
    <footer-links v-for="item in menu" :key="item.title" v-qa="'footer-menu'">
      <template v-slot:title>{{ item.title }}</template>

      <nuxt-link
        v-for="link in item.links"
        :key="link.label"
        v-qa="'footer-menu-link'"
        :to="localePath(link.url)"
        class="nav-link">
        {{ link.label }}
      </nuxt-link>
    </footer-links>
  </div>
</template>

<script>
import FooterLinks from '~/components/footer/links';

export default {
  name: 'FooterMenu',
  components: { FooterLinks },
  props: {
    menu: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.right {
  @include tablet {
    width: 50%;
    display: flex;
    justify-content: space-between;
  }
}

.nav-link {
  font-weight: 500;
  color: map_get($colors, text);
  opacity: 0.5;
  margin-bottom: 20px;
}
</style>
